var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00255 6.95573L2.90584 4.13907C2.80051 4.04327 2.67587 3.99696 2.53192 4.00015C2.38797 4.00335 2.26333 4.05285 2.158 4.14865C2.05267 4.24446 2 4.35783 2 4.48876C2 4.61969 2.05267 4.73306 2.158 4.82886L5.40217 7.77007C5.48643 7.84671 5.58123 7.90419 5.68656 7.94252C5.79189 7.98084 5.89722 8 6.00255 8C6.10788 8 6.21321 7.98084 6.31854 7.94252C6.42387 7.9042 6.51867 7.84671 6.60293 7.77007L9.8471 4.81928C9.95243 4.72348 10.0033 4.61171 9.99983 4.48397C9.99632 4.35623 9.9419 4.24446 9.83657 4.14865C9.73124 4.05285 9.6066 4.00495 9.46265 4.00495C9.31869 4.00495 9.19405 4.05285 9.08872 4.14865L6.00255 6.95573Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownS);
export default __webpack_public_path__ + "static/media/arrow-down-s.1315b311c29fe126626534bb99248c59.svg";
export { ForwardRef as ReactComponent };